import { mutatorAction } from 'satcheljs';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import CLPViewState from '../../store/schema/clp/CLPViewState';

export default mutatorAction(
    'setTempCLPLabel',
    (clpViewState: CLPViewState, labelToSet: CLPLabel) => {
        clpViewState.tempCLPLabel = labelToSet;
    }
);
